import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGridInterface3Line = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.99072 3.89725C4.97541 2.84114 6.3776 2.25 8.03301 2.25H16.4675C18.1268 2.25 19.5292 2.84085 20.513 3.89769C21.4911 4.94847 21.9995 6.3989 21.9995 8.02625V15.9733C21.9995 17.6006 21.4911 19.0511 20.5128 20.1019C19.5289 21.1587 18.1263 21.7495 16.4665 21.7495H8.03301C6.37371 21.7495 4.97111 21.1587 3.9871 20.1019C3.00871 19.0512 2.5 17.6007 2.5 15.9733V8.02625C2.5 6.39786 3.01146 4.94754 3.99072 3.89725ZM5.08783 4.92016C4.41041 5.64672 4 6.70952 4 8.02625V15.9733C4 17.2909 4.40878 18.3536 5.08488 19.0797C5.75537 19.7998 6.74428 20.2495 8.03301 20.2495H16.4665C17.7558 20.2495 18.7447 19.7998 19.415 19.0798C20.0909 18.3537 20.4995 17.291 20.4995 15.9733V8.02625C20.4995 6.70848 20.0909 5.64579 19.4151 4.91972C18.7448 4.19972 17.7562 3.75 16.4675 3.75H8.03301C6.74915 3.75 5.75983 4.19943 5.08783 4.92016Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.25 2.25C12.6642 2.25 13 2.58579 13 3V20.9995C13 21.4137 12.6642 21.7495 12.25 21.7495C11.8358 21.7495 11.5 21.4137 11.5 20.9995V3C11.5 2.58579 11.8358 2.25 12.25 2.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.5 12C2.5 11.5858 2.83579 11.25 3.25 11.25H21.2495C21.6637 11.25 21.9995 11.5858 21.9995 12C21.9995 12.4142 21.6637 12.75 21.2495 12.75H3.25C2.83579 12.75 2.5 12.4142 2.5 12Z",
			fill: "currentColor"
		})
	]
});
export default SvgGridInterface3Line;
